module.exports = __webpack_public_path__ + "img/pethouse49.1b7491b4.jpg";